<template>
  <div class="output-line mono">{{ displayLine | atMost }}</div>
</template>

<script>
import utils from 'oderon-commons/src/utils.js'
import brush from 'brush'
import { bytesToDate } from 'horus-parser/src/utils.js'
import moment from 'moment'

function signedUnsigned(bytes) {
  const u = brush.toUint(bytes)
  const s = brush.toInt(bytes)
  return `unsigned=${u} signed=${s}`
}

function asciiArray(arr) {
  return arr.map((x) => asciiChar(x, { nonPrintable: true })).join(' ')
}

function asciiChar(n, { nonPrintable = false } = {}) {
  if (n == null) return null
  if (n == 10) return 'LF'
  if (n == 13) return 'CR'
  if (n == 32) return 'SPC'
  if (n > 32 && n <= 126) return String.fromCharCode(n)
  if (nonPrintable) return '0x' + n.toString(16).padStart(2, '0')
  return null
}

function byteMask(spec, byte) {
  const result = spec.split(' ').reduce((acc, piece, i) => {
    if (piece != 'R' && (byte & (1 << (7 - i))) > 0) acc.push(piece)
    return acc
  }, [])
  if (result.length == 0) return '-'
  return result.join(' ')
}

export default {
  props: {
    line: { required: true }
  },
  computed: {
    displayLine() {
      // NB: aqui a line já é trimmed
      let line = this.line
      let hash = ''
      let lowerHash = ''
      if (line.length < 1) return ' '
      if (line.charAt(0) == '#') return line

      // Se temos chars e depois um #, considera a line até
      // a hash, e guarda a hash para mostrar depois.
      const h = line.indexOf('#')
      if (h > 0) {
        hash = line.substring(h + 1).trim()
        lowerHash == hash.toLowerCase()
        line = line.substring(0, h).trim()
      }

      if (!line.match(/^[a-f0-9\s]*$/)) return line

      // Aqui, é hex. Mas se o número de chars não for par, é um erro
      // (não faremos padding com 0)
      line = line.replaceAll(/\s+/g, '')
      if (line.length % 2 != 0) return `${line.length} chars: ${line}`

      // Hex válido, converte para bytes.
      const bytes = brush.hexToBytes(line)

      // Se a hash é o hint "ascii", converte tudo para ascii
      // usando o formato antigo.
      if (hash == 'ascii') {
        hash = null
        return asciiArray(bytes)
      }

      if (bytes.length == 1) {
        const n = bytes[0]
        const d = n.toString()
        const b = n.toString(2).padStart(8, '0')

        let a = asciiChar(n)
        if (a != null) a = 'ASCII:' + a
        else a = ''

        if (hash == 'lapse') {
          return byteMask('CC0 CC1 RPM SPEED DG ACCEL AN1 EXP1', n)
        } else if (hash == 'dg') {
          return byteMask('DG3 BRAKE DG1 DG2 BUZZ ACT INCOD NOTFX', n)
        } else if (hash == 'exp1') {
          return byteMask('AN2 AN3 AN4 STATE POLY GPS OPE EXP2', n)
        } else if (hash == 'exp2') {
          return byteMask('FLAGS R R R R R R EXP3', n)
        } else if (hash == 'flags') {
          return byteMask('NOTFX GPSVL RPMAC R R R R R', n)
        }

        return `dec=${d} bin=${b} ${a}`
      }

      if (bytes.length == 2 || bytes.length == 3 || bytes.length == 4) {
        return signedUnsigned(bytes)
      }

      if (bytes.length == 6) {
        return moment(bytesToDate(bytes)).format()
      }

      if (bytes.length >= 8 && line.includes('484f525553594e43')) {
        const i = line.indexOf('484f525553594e43')
        const j = i + 16
        return line.substring(0, i) + '_HORUSYNC_______' + line.substring(j)
      }

      return `${bytes.length} bytes: ` + line
    }
  },
  filters: {
    atMost(x) {
      return utils.atMost(x, 64)
    }
  }
}
</script>

<style lang="sass">
.output-line
  border-radius: 3px
  background-color: #eee
  font-size: 14px
  line-height: 18px
  margin: 2px
  white-space: pre

  &:first-of-type
    margin-top: 3px
</style>
